import { biLoggerFactory } from 'wix-private';

const msid = '27521b16-8382-4037-a0be-cf987589f154';

const biGroupsLoggers = {
    19: biLoggerFactory('lp', 19, { msid }),
    20: biLoggerFactory('branded-app-webinar', 19, { msid }),

}

export async function fireBIEvent(src, evid, fields) {

    const biLogger = biGroupsLoggers[src];
    try {
        const biEventObject = {
            evid,
            ...fields
        };
        await biLogger.log(biEventObject);
    } catch (err) {
        console.error(`Failed to fireBIEvent -err- ${err}`);
    }
}